import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Ransom Arbitrator · Your Trusted Consultancy</p>
        <h1>Resolve Ransom Disputes with Confidence</h1>
        <p className="lede">
          At Ransom Arbitrator, we specialize in navigating the complexities of ransom disputes and providing tailored risk management strategies. Our expert team is dedicated to helping you regain control and peace of mind.
        </p>
        <div className="cta-row">
          <a href="/services" target="_self">
            Explore Our Services
          </a>
          <a href="/contact" target="_self" className="secondary">
            Get in Touch
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Expert Guidance</h2>
          <p>
            Our experienced consultants work closely with you to understand your unique situation and provide actionable insights to resolve disputes effectively.
          </p>
        </article>
        <article>
          <h2>Comprehensive Risk Management</h2>
          <p>
            We offer robust risk management strategies designed to protect your interests and minimize potential threats in the future.
          </p>
        </article>
        <article>
          <h2>Confidential Support</h2>
          <p>
            Trust is paramount. We ensure that all consultations are conducted with the highest level of confidentiality and professionalism.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;